import "./style.css";
import { TechsViewItems } from "../../components/techs/TechsViewItems";

export function TechsView() {
  return (
    <div id="techs" className="techs_div">
      <div className="techs_items_title">
        <div className="techs_it_div">
          <img src="./img/jishubt.png" />
        </div>
      </div>
      <div className="techs_items">
        <TechsViewItems />
      </div>
    </div>
  );
}
